import * as React from 'react';
import Box from '@mui/material/Box';
import { FormControl, Button, Divider, Typography } from '@mui/material';
import Grid from "@mui/material/Grid2";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useStoreActions } from "easy-peasy";
import api from '../../../services/api';
import { TextField } from "../../../components";
import { optionsDropdown } from './static';
import { Autocomplete } from '../../../components';

const Dados = ({ano, empresa}) => {

  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const schema = yup.object({
    // Estabelecer uma cultura em segurança de processo
    agendaSegurancaReunioes: yup.number().positive().nullable().label('Selecione a frequência'),
    segurancaPlanosOrcamentos: yup.number().positive().nullable().label('Selecione a frequência'),
    preocupacoesSegurancaOperacional: yup.number().positive().nullable().label('Selecione a frequência'),
    statusSegurancaReunioes: yup.number().positive().nullable().label('Selecione a frequência'),
    acaoManutencaoFalhas: yup.number().positive().nullable().label('Selecione a frequência'),
    // Proporcionar liderança e compromisso da alta liderança
    operadoresBarreirasProcesso: yup.number().positive().nullable().label('Selecione a frequência'),
    atividadesSegurancaGestao: yup.number().positive().nullable().label('Selecione a frequência'),
    atribuicaoBaseCompetencia: yup.number().positive().nullable().label('Selecione a frequência'),
    melhoriasSistemaGestao: yup.number().positive().nullable().label('Selecione a frequência'),
    // Implementar um programa detalhado de GSPM
    treinamentoPadroesSeguranca: yup.number().positive().nullable().label('Selecione a frequência'),
    avaliacaoDesviosPadroes: yup.number().positive().nullable().label('Selecione a frequência'),
    verificacaoEquipamentosExistentes: yup.number().positive().nullable().label('Selecione a frequência'),
    atualizacaoPadroesEquipamentos: yup.number().positive().nullable().label('Selecione a frequência'),
    treinamentoRiscosLocal: yup.number().positive().nullable().label('Selecione a frequência'),
    avaliacaoLimitesOperacionais: yup.number().positive().nullable().label('Selecione a frequência'),
    modificacoesProcessosEquipamentos: yup.number().positive().nullable().label('Selecione a frequência'),
    // Aprender com a Experiência
    especialistasInvestigacoesIncidentes: yup.number().positive().nullable().label('Selecione a frequência'),
    investigacaoCausasRaiz: yup.number().positive().nullable().label('Selecione a frequência'),
    licoesAprendidasEmpresa: yup.number().positive().nullable().label('Selecione a frequência'),
    discussaoInvestigacoesReunioes: yup.number().positive().nullable().label('Selecione a frequência'),
    aprendizadosPadroesInternos: yup.number().positive().nullable().label('Selecione a frequência'),
    observacoes: yup
      .string()
      .max(1000, "Máximo 1000 caracteres")
      .label(
        "Deixe seu comentário ou outras informações que considerar importante"
      ).nullable(),
  }).required();

  const useFormRef = useForm({
    mode: "onTouched",
    resolver: yupResolver(schema),
  });


  const {
    handleSubmit,
    reset,
    formState: { isDirty, isSubmitting },
  } = useFormRef;

  const loadDados = async (mount) => {
    startLoading();
    try {
      let url = "01/dados/empresa/" + empresa + "/" + ano;
      let getRegistros = (await api.http.get(url));
      if(mount.isMounted) {
        reset(getRegistros.data);
      }
      stopLoading();
    } catch (error) {
      if(error.response && error.response.status==404) {
        if(mount.isMounted) {
          reset({
            ano: ano,
            // Estabelecer uma cultura em segurança de processo
            agendaSegurancaReunioes: null,
            segurancaPlanosOrcamentos: null,
            preocupacoesSegurancaOperacional: null,
            statusSegurancaReunioes: null,
            acaoManutencaoFalhas: null,
            // Proporcionar liderança e compromisso da alta liderança
            operadoresBarreirasProcesso: null,
            atividadesSegurancaGestao: null,
            atribuicaoBaseCompetencia: null,
            melhoriasSistemaGestao: null,
            // Implementar um programa detalhado de GSPM
            treinamentoPadroesSeguranca: null,
            avaliacaoDesviosPadroes: null,
            verificacaoEquipamentosExistentes: null,
            atualizacaoPadroesEquipamentos: null,
            treinamentoRiscosLocal: null,
            avaliacaoLimitesOperacionais: null,
            modificacoesProcessosEquipamentos: null,
            // Aprender com a Experiência
            especialistasInvestigacoesIncidentes: null,
            investigacaoCausasRaiz: null,
            licoesAprendidasEmpresa: null,
            discussaoInvestigacoesReunioes: null,
            aprendizadosPadroesInternos: null,
            observacoes: ""
          });
        }
        stopLoading();
      } else {
        stopLoading({
          message: error.toString(),
          severity: "error",
        });
      }
    }
  };

  const submit = async (data) => {
    startLoading();
    try {
      let result
      if(data.id) {
        result = (await api.http.put(
          "01/dados/empresa/" + empresa + "/" + data.id,
          { ...data }
        ));
      } else {
        result = (await api.http.post(
          "01/dados/empresa/" + empresa,
          { ...data, ano: ano }
        ));
      }
      reset(result.data);
      stopLoading({ severity: "success" });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
      throw error;
    }
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadDados(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [ano, empresa]);

  return (
    <div>
      <Divider>
        <h3>Estabelecer uma cultura em segurança de processo</h3>
      </Divider>

      <Grid container spacing={2} sx={{
        alignItems: 'center',
        paddingBottom: 3,
        '& .MuiTypography-root': {  textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            Os tópicos de segurança de processo são itens regulares da agenda em reuniões de diretoria/executivas?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="agendaSegurancaReunioes"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            As atividades de segurança de processo estão incluídas nos planos operacionais e orçamentos anuais?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="segurancaPlanosOrcamentos"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            Pessoas em nível operacional levantam livremente as preocupações de segurança do processo para supervisão e gerentes?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="preocupacoesSegurancaOperacional"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            O status da investigação de incidentes, resultados de auditoria e outros itens de ação 
            relacionados à segurança de processo são discutidos regularmente nas reuniões de produção da unidade?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="statusSegurancaReunioes"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            Os planos de trabalho de manutenção incluem a ação apropriada
            a ser tomada se o trabalho não sair conforme o planejado?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="acaoManutencaoFalhas"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
      </Grid>

      {/* ### */}

      <Divider>
        <h3>Proporcionar liderança e compromisso da alta liderança</h3>
      </Divider>

      <Grid container spacing={2} sx={{
        alignItems: 'center',
        paddingBottom: 3,
        '& .MuiTypography-root': {  textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            Os operadores envolvidos no processo podem descrever as barreiras do local 
            (o que são, para que servem, como funcionam) que controlam os perigos e riscos
            de acidentes graves de sua operação?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="operadoresBarreirasProcesso"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            O sistema de gestão define as atividades relacionadas à segurança de processo que são conduzidas pela empresa
            (por exemplo, identificação de perigos, MOCs, investigação de incidentes e rastreamento de itens de ação)?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="atividadesSegurancaGestao"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            O sistema de gestão garante que os funcionários sejam atribuídos a funções com base em sua competência
            para executar as tarefas esperadas dessa função?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="atribuicaoBaseCompetencia"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            O sistema de gestão possui um mecanismo que incentiva e facilita a identificação de 
            oportunidades de melhoria no sistema de gestão por todos os colaboradores?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="melhoriasSistemaGestao"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
      </Grid>

      {/* ### */}

      <Divider>
        <h3>Implementar um programa detalhado de GSPM</h3>
      </Divider>

      <Grid container spacing={2} sx={{
        alignItems: 'center',
        paddingBottom: 3,
        '& .MuiTypography-root': {  textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            Os funcionários que podem afetar o desempenho da segurança de processo recebem 
            treinamento formal sobre os padrões relevantes do setor, seu conteúdo e uso?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="treinamentoPadroesSeguranca"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            Quando existe um processo para aprovação de desvios dos padrões para equipamentos 
            existentes, ele requer uma avaliação de risco e aprovação de um nível apropriado de gerenciamento?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="avaliacaoDesviosPadroes"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            Existe um processo (ou seja, auditorias ou outras avaliações) para verificar 
            periodicamente se o equipamento existente está apto para o serviço?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="verificacaoEquipamentosExistentes"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            Existe um sistema para revisar, atualizar e reemitir periodicamente os padrões internos 
            para os equipamentos existentes?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="atualizacaoPadroesEquipamentos"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            O pessoal (ou seja, operadores, engenheiros, líderes, gerentes de unidade) recebe 
            treinamento sobre os perigos e barreiras/salvaguardas do processo do local que serão
            responsáveis por gerenciar no início de uma nova atribuição?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="treinamentoRiscosLocal"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            A compreensão do operador sobre os limites operacionais seguros e as etapas para 
            corrigir ou evitar desvios é demonstrada por meio de testes, avaliações ou revisão
            de seu trabalho?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="avaliacaoLimitesOperacionais"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            O projeto de engenharia e modificações de processo e
            equipamentos são verificados por profissional com conhecimento em segurança de
            processos, em um nível proporcional ao risco
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="modificacoesProcessosEquipamentos"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
      </Grid>

      {/* ### */}

      <Divider>
        <h3>Aprender com a Experiência</h3>
      </Divider>

      <Grid container spacing={2} sx={{
        alignItems: 'center',
        paddingBottom: 3,
        '& .MuiTypography-root': {  textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            Especialistas no assunto estão incluídos nas investigações de incidentes?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="especialistasInvestigacoesIncidentes"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            As investigações de incidentes e quase acidentes identificam as causas-raiz, incluindo o
            fator humano e as causas baseadas na liderança?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="investigacaoCausasRaiz"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            Existe um processo formal para compartilhar as lições aprendidas dentro da empresa?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="licoesAprendidasEmpresa"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            O status, as descobertas e os itens de ação da investigação de incidentes de processo são
            discutidos regularmente nas reuniões de produção da unidade?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="discussaoInvestigacoesReunioes"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
        }}>
          <Typography>
            A empresa incorpora aprendizados (de incidentes internos/externos, mudanças nos
            padrões do setor, desenvolvimento de novas tecnologias, boas práticas reconhecidas)
            em padrões internos?
          </Typography>
        </Grid>
        <Grid
          size={{
           md: 4
        }}>
          <FormControl fullWidth>
            <Autocomplete
              field="aprendizadosPadroesInternos"
              options={optionsDropdown}
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
      </Grid>

      {/* ### */}

      <Divider>
        <h3>Observações</h3>
      </Divider>
      <FormControl sx={{ my: 2 }} fullWidth>
        <TextField
          field="observacoes"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      <Box>
        <Button variant="outlined" sx={{ mr: 2 }}
                onClick={()=>{reset();}} disabled={!isDirty || isSubmitting}>
          CANCELAR
        </Button>
        <Button
          type="submit"
          variant="contained"
          sx={{ m: 1 }}
          onClick={handleSubmit(submit)}
          disabled={!isDirty || isSubmitting}
        >
          Salvar
        </Button>
      </Box>

    </div>
  );
};

export default Dados;
